<template>
  <v-menu offset-y v-if="user">
    <template v-slot:activator="{ on, attrs }">
      <v-avatar
        color="rgba(251, 109, 59, 0.15)"
        class="avatar-text"
        size="50"
        v-bind="attrs"
        v-on="on"
        :class="{
          'avatar-loading': loading.questionnaires || loading.restaurantQuestionnaires,
        }"
      >
        <v-progress-circular
          v-if="loading.questionnaires || loading.restaurantQuestionnaires"
          indeterminate
          color="primary"
          size="20"
          width="2"
        ></v-progress-circular>
        <span v-else style="" class="text-white">
          {{ toLatin(user.name.charAt(0).toUpperCase()) }}
          {{
            user.lastname != null ? toLatin(user.lastname.charAt(0).toUpperCase()) : ""
          }}
        </span>
      </v-avatar>
    </template>
    <v-list>
      <v-list-item
        v-if="item.title !== 'anketa' || (item.title === 'anketa' && hasQuestionare)"
        v-for="(item, index) in listItems"
        :key="index"
        :to="item.to"
        @click="item.click ? item.click() : null"
      >
        <v-list-item-title>
          <v-icon v-html="item.icon" small class="pr-2"></v-icon>
          {{ $t(item.title) }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapState } from "vuex";
import companyService from "@/services/company";
import restaurantService from "@/services/restaurant";
import hasSnackbar from "@/mixins/hasSnackbar";

export default {
  name: "AppAvatarMenu",
  mixins: [hasSnackbar],
  data() {
    return {
      questionares: [],
      hasQuestionare: false,
      loading: {
        questionnaires: false,
        restaurantQuestionnaires: false,
      },
    };
  },
  computed: {
    ...mapState(["company"]),
    user() {
      return this.$store.state.user.user;
    },

    listItems() {
      let routes = [
        { title: "profile", icon: "mdi-account", to: { name: "profil" } },
        { title: "qr_code", icon: "mdi-qrcode", to: { name: "qrShow" } },
        { title: "info", icon: "mdi-information", to: { name: "info" } },
      ];

      const isUserCompanyType = this.user?.type === "company";

      if (typeof this.company?.settings == "string") {
        if (
          this.company?.settings &&
          JSON.parse(this.company.settings).can_see_report &&
          JSON.parse(this.company.settings).can_see_report != null
        ) {
          routes.splice(2, 0, {
            title: "report",
            icon: "mdi-chart-timeline-variant",
            to: {
              name: isUserCompanyType ? "izvestajFirma" : "izvestaj-naplata",
            },
          });
        }
      } else {
        if (this.company?.settings?.can_see_report != null) {
          routes.splice(2, 0, {
            title: "report",
            icon: "mdi-chart-timeline-variant",
            to: {
              name: isUserCompanyType ? "izvestajFirma" : "izvestaj-naplata",
            },
          });
        }
      }

      if (this.questionares.length) {
        this.questionares.forEach((q, i) => {
          routes.push({
            title: "Anketa " + (i + 1),
            icon: "mdi-information",
            to: { name: "questionnaire", params: { q } },
          });
        });
      }
      routes.push({
        title: "logout",
        icon: "mdi-power",
        click: this.logout,
      });
      return routes;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("user/LOGOUT");
    },
    setupQuestionnaires() {
      this.questionares = [];
      if (!this.company?.id) return;
      if (this.loading.questionnaires) return;

      this.loading.questionnaires = true;
      companyService
        .getQuestionnaire(this.company.id)
        .then((res) => {
          if (res.data?.length) {
            this.hasQuestionare = true;
            this.questionares.push(
              res.data.filter((q) => q.roles.includes(this.user.type))
            );
          } else {
            this.hasQuestionare = false;
          }
        })
        .catch((err) => {
          console.error("Error loading questionnaires:", err);
          if (err.response?.status === 429) {
            this.hasQuestionare = true;
          } else {
            this.hasQuestionare = false;
            this.showErrorSnackbar(err, this.$t("error_loading_questionnaires"));
          }
        })
        .finally(() => {
          this.loading.questionnaires = false;
        });
    },
    setupRestaurantQuestionnaires() {
      if (!this.$store.state.restaurant?.id) return;
      if (this.loading.restaurantQuestionnaires) return;

      this.loading.restaurantQuestionnaires = true;
      restaurantService
        .getRestaurantQuestionnaires(this.$store.state.restaurant.id)
        .then((res) => {
          this.hasQuestionare = true;
          this.questionares.push(
            res.data.filter((q) => q.roles.includes(this.user.type))
          );
        })
        .catch((error) => {
          console.error("Error loading restaurant questionnaires:", error);
          this.hasQuestionare = this.hasQuestionare || false;
          this.showErrorSnackbar(error, this.$t("error_loading_questionnaires"));
        })
        .finally(() => {
          this.loading.restaurantQuestionnaires = false;
        });
    },
  },
  watch: {
    company: {
      handler(newCompany) {
        if (newCompany) {
          this.setupQuestionnaires();

          // Setup restaurant questionnaires if restaurant exists
          if (this.$store.state.restaurant) {
            this.setupRestaurantQuestionnaires();
          }
        }
      },
      immediate: true,
    },
    "$store.state.restaurant"(newRestaurant) {
      if (newRestaurant && this.company) {
        this.setupRestaurantQuestionnaires();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.avatar-text {
  color: $primary-color;
  font-size: 13px;
}

.avatar-loading {
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}
</style>
